import { render, staticRenderFns } from "./xy-page-container.vue?vue&type=template&id=f40304e6"
import script from "./xy-page-container.vue?vue&type=script&lang=js"
export * from "./xy-page-container.vue?vue&type=script&lang=js"
import style0 from "./xy-page-container.vue?vue&type=style&index=0&id=f40304e6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports